import { InferType, object } from 'yup';
import { Nullable } from '../../../model/common';
import { PriceSchemaParams, QuantitySchemaParams, priceSchema, quantitySchema, safeString } from './common';

interface AmendOrderSchemaParams extends PriceSchemaParams, QuantitySchemaParams {}

export const amendOrderSchema = (params: AmendOrderSchemaParams) => {
    return object({
        pair: safeString(),
        side: safeString(),
        ccy: safeString(),
        orderType: safeString(),
        orderId: safeString(),
        status: safeString(),
        duration: safeString(),
        quantity: quantitySchema(params),
        price: priceSchema(params)
    });
};

export type AmendOrderFormValues = InferType<ReturnType<typeof amendOrderSchema>>;
export type AmendOrderFormInput = Nullable<AmendOrderFormValues>;
